<template>
  <el-dialog title="往来商户信息删除" :visible.sync="showDeleteDialog">
    <span class="dialog-flex"
      ><i class="warning el-icon-warning" />此操作将永久删除{{ ids.length }}条商户信息，是否继续？</span
    >
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDeleteDialog = false">取 消</el-button>
      <el-button type="primary" @click="deleteConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['ids'],
  data() {
    return {
      showDeleteDialog: false,
    };
  },
  methods: {
    openDialog() {
      this.showDeleteDialog = true;
    },
    deleteConfirm() {
      this.showDeleteDialog = false;
      this.$emit('deleteBind')
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-flex {
  font-size: 16px;
  color: #666666;
  display: flex;
  align-items: center;
}
.warning {
  color: #ff9f07;
  font-size: 20px;
  margin-right: 7px;
}
</style>
